type Widget = {
  render(
    element: HTMLElement,
    options: {
      sitekey: string;
      callback(token: string): void;
      "error-callback"(): void;
      "expired-callback"?(): void;
      "timeout-callback"?(): void;
    },
  ): string;
  reset(id: string): void;
  remove?(id: string): void;
};
let cleanup: (() => void) | undefined;
export function stopFormProtection(): void {
  cleanup?.();
  cleanup = undefined;
}
export function startFormProtection(
  node: HTMLElement,
  sitekey: string,
  cs: boolean,
  setToken: (token: string) => void,
  text?: (key: string, fallback: string) => string,
): void {
  const label = (key: string, czech: string, english: string) =>
    text?.(key, cs ? czech : english) ?? (cs ? czech : english);
  stopFormProtection();
  setToken("");
  let disposed = false;
  let timer = 0;
  let widget: string | undefined;
  let settled = false;
  const api = () => window.turnstile as Widget | undefined;
  const status = document.createElement("p");
  status.setAttribute("role", "status");
  const target = document.createElement("div");
  const retry = document.createElement("button");
  retry.type = "button";
  retry.className = "button secondary";
  retry.textContent = label(
    "protection.retry",
    "Zkusit ověření znovu",
    "Retry verification",
  );
  retry.hidden = true;
  retry.onclick = () => startFormProtection(node, sitekey, cs, setToken, text);
  node.replaceChildren(status, target, retry);
  status.textContent = label(
    "protection.loading",
    "Načítám ochranu formuláře…",
    "Loading form protection…",
  );
  const fail = () => {
    if (disposed) return;
    settled = true;
    setToken("");
    status.textContent = label(
      "protection.unavailable",
      "Ověření není připravené nebo vypršelo. Zkuste je načíst znovu; vaše údaje zůstaly zachované.",
      "Verification is unavailable or expired. Retry; your details have been preserved.",
    );
    retry.hidden = false;
  };
  let script = document.querySelector<HTMLScriptElement>(
    "script[data-booking-turnstile]",
  );
  if (script && !api()?.render) {
    script.remove();
    script = null;
  }
  if (!script && !api()?.render) {
    script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.dataset.bookingTurnstile = "true";
    document.head.append(script);
  }
  script?.addEventListener("error", fail);
  const started = Date.now();
  const wait = () => {
    if (disposed || !node.isConnected) return;
    if (settled) return;
    if (Date.now() - started >= 15_000) return fail();
    if (!api()?.render) {
      timer = window.setTimeout(wait, 100);
      return;
    }
    try {
      widget = api()!.render(target, {
        sitekey,
        callback(token) {
          if (disposed) return;
          settled = true;
          setToken(token);
          status.textContent = label(
            "protection.ready",
            "Ověření připravené.",
            "Verification ready.",
          );
          retry.hidden = true;
          window.clearTimeout(timer);
        },
        "error-callback": fail,
        "expired-callback": fail,
        "timeout-callback": fail,
      });
      if (!settled) timer = window.setTimeout(fail, 30_000);
    } catch {
      fail();
    }
  };
  cleanup = () => {
    disposed = true;
    window.clearTimeout(timer);
    script?.removeEventListener("error", fail);
    if (widget) {
      try {
        api()?.remove?.(widget);
      } catch {
        /* detached widget */
      }
    }
    setToken("");
  };
  wait();
}
